export const trigger = (data) => {
  window.LIFE_CYCLE_EVENT_BUS.trigger('packages-mini.title-click', data);
};
